import { render, staticRenderFns } from "./StrateContact.vue?vue&type=template&id=3994d4b2&"
import script from "./StrateContact.vue?vue&type=script&lang=js&"
export * from "./StrateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports